import "pixi.js";
import "@goldenrockstud/pixi-spine";

import Logger = require("js-logger");
import { Texture } from "pixi.js";
import { AssetConfigSchema } from "slotworks/config/asset-config-schema";
import graphicsManager from "slotworks/graphics/graphics-manager";

class SpineManager {

    private spineData: Map<string, PIXI.spine.core.SkeletonData> = new Map<string, PIXI.spine.core.SkeletonData>();

    public init(config: AssetConfigSchema) {
        const layoutConfig = config.layouts.all;
        const spineConfig = layoutConfig.spines;

        for (const name in spineConfig) {
            if (spineConfig.hasOwnProperty(name)) {
                const spineJSON = spineConfig[name];
                this.spineData.set(name, this.generateSpineData(name, spineJSON));
            }
        }
    }

    public update(time: number) {
        //
    }

    public createSpine(name: string) {
        if (!this.spineData.get(name)) {
            throw new Error("Spine `" + name + "` does not exist in spine cache");
        }

        const spineData = this.spineData.get(name);
        return new PIXI.spine.Spine(spineData);
    }

    private generateSpineData(name: string, spineJSON: any) {
        const spineAtlas = this.generateSpineAtlas(name, spineJSON);

        const spineAtlasLoader = new PIXI.spine.core.AtlasAttachmentLoader(spineAtlas);
        const spineJsonParser = new PIXI.spine.core.SkeletonJson(spineAtlasLoader);

        return spineJsonParser.readSkeletonData(spineJSON);
    }

    private generateSpineAtlas(name: string, spineData: any) {
        const spineAtlas = new PIXI.spine.core.TextureAtlas();
        const allTextures: { [key: string]: Texture; } = {};

        const skins = spineData.skins;

        for (const skin of skins) {
            for (const attachmentKey in skin.attachments) {
                if (skin.attachments.hasOwnProperty(attachmentKey)) {
                    const slots = skin.attachments[attachmentKey];
                    for (const slotKey in slots) {

                        if (slots.hasOwnProperty(slotKey)) {
                            const slot = slots[slotKey];
                            const textureId = slot.path || slotKey;
                            const textureName = name + "/" + (textureId);
                            if (graphicsManager.hasTexture(textureName)) {
                                allTextures[textureId] = graphicsManager.getTexture(textureName);
                            } else {
                                if (slot.type !== "clipping") {
                                    Logger.warn("Spine texture not found ", textureId);
                                }
                            }
                        }
                    }
                }
            }
        }

        spineAtlas.addTextureHash(allTextures, true);

        return spineAtlas;
    }
}

export default new SpineManager();
